export enum MessageContentType {
	Text = 'Text',
	Image = 'Image',
	Video = 'Video',
	Audio = 'Audio',
	File = 'File',
	Link = 'Link',
	RichText = 'RichText',
	Mention = 'Mention',
	CodeBlock = 'CodeBlock',
}

export interface TextFormatting {
	bold?: boolean;
	italic?: boolean;
	underline?: boolean;
	strikethrough?: boolean;
	code?: boolean;
}

export interface MentionData {
	userId: string;
	username: string;
	displayName: string;
}

export interface MessageContentMetadata {
	fileName?: string;
	fileSize?: number;
	mimeType?: string;
	duration?: number;
	dimensions?: { width: number; height: number };
	preview?: string;
	progress?: number;
	isPlaying?: boolean;
}

export class MessageContent {
	type: MessageContentType;
	content: string;
	mentions: MentionData[];
	formatting?: TextFormatting;
	metadata?: MessageContentMetadata;

	constructor(
		type: MessageContentType,
		content: string,
		mentions: MentionData[] = [],
		formatting?: TextFormatting,
		metadata?: MessageContentMetadata
	) {
		this.type = type;
		this.content = content;
		this.mentions = mentions;
		this.formatting = formatting;
		this.metadata = metadata;
	}

	static createText(content: string, formatting?: TextFormatting): MessageContent {
		return new MessageContent(MessageContentType.Text, content, [], formatting);
	}

	static createMention(userId: string, username: string, displayName: string): MessageContent {
		return new MessageContent(MessageContentType.Mention, `@${username}`, [
			{ userId, username, displayName },
		]);
	}

	static createMedia(
		type: MessageContentType.Image | MessageContentType.Video | MessageContentType.Audio,
		url: string,
		metadata?: any
	): MessageContent {
		return new MessageContent(type, url, [], undefined, metadata);
	}

	static fromJson(json: any): MessageContent {
		return new MessageContent(
			json.type,
			json.content,
			json.mentions,
			json.formatting,
			json.metadata
		);
	}

	toJson(): any {
		return {
			type: this.type,
			content: this.content,
			mentions: this.mentions,
			formatting: this.formatting,
			metadata: this.metadata,
		};
	}
}
